var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-with-logo"},[_c('img',{staticClass:"modal-with-logo__logo",attrs:{"src":require("@/assets/ak-logo-badge--solid-dark.svg")}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }